namespace Vit.Administration {
    export interface UserTenantRoleDialogOptions {
        userID: number;
        username: string;
    }

    @Serenity.Decorators.registerClass()
    export class UserTenantRoleDialog extends Serenity.TemplatedDialog<UserTenantRoleDialogOptions> {
        // private readonly businessUnitsLookupEditor: BusinessUnitsLookupEditor;
        // private readonly businessUnitsLookupEditor: Serenity.ServiceLookupEditor;
        private readonly businessUnits: UserRoleBusinessUnitsGrid;
        private readonly permissions: RoleCheckEditor;

        constructor(opt: UserTenantRoleDialogOptions) {
            super(opt);

            // this.businessUnitsLookupEditor = new BusinessUnitsLookupEditor(this.byId("BusinessUnitsLookupEditor"), {
            // this.businessUnitsLookupEditor = new ServiceLookupEditor(this.byId("BusinessUnitsLookupEditor"), {
            //     idField: "",
            //     textField: "",
            //     // service: "",
            //     // idField: "",
            //     // textField: "",
            //     // sort: [],
            //     // includeColumns: ["", ""],
            // });

            //UserTenantRoleService.List({
            //    UserID: this.options.userID,
            //}, response => {
            //    this.businessUnits.setItems(response.Entities.map(item => {
            //        return {
            //            [UserTenantRoleRow.idProperty]: item,
            //        };
            //    }));
            //});

            this.businessUnits = new UserRoleBusinessUnitsGrid(this.byId("BusinessUnits"));
            this.businessUnits.getGrid().onClick.subscribe((event: JQueryEventObject, args) => {
                // console.log(args.grid.getData().getItemByIdx(args.row));
                // this.permissions.value = response.Entities.map(x => x.toString());
                const data = args.grid.getData().getItemByIdx(args.row);

                /*/!* TODO: 4 Test *!/
                for (const prop in data) {
                    const item = data[prop];

                    if (item) {
                        data[prop] = item.toString();
                    }
                }*/

                this.permissions.value = [data[UserTenantRoleRow.idProperty]];
            });
            this.permissions = new RoleCheckEditor(this.byId("Roles"));
        }

        protected getTemplate() {
            // return '<div id="s-DialogContent"><div id="~_BusinessUnitsLookupEditor"></div><div id="~_BusinessUnits"></div><div id="~_Roles"></div></div>';
            return '<div id="s-DialogContent"><div id="~_BusinessUnits"></div><div id="~_Roles"></div></div>';
        }

        protected getDialogOptions() {
            let opt = super.getDialogOptions();

            //opt.title = Q.format(Q.text("Site.UserRoleDialog.DialogTitle"), this.options.username);
            //opt.buttons = [{
            //    text: Q.text("Dialogs.OkButton"),
            //    click: () => {
            //        UserTenantRoleService.Update({
            //            UserID: this.options.userID,
            //            // Entities:,
            //        }, response => {
            //            debugger;
            //            // this.dialogClose();
            //            // Q.notifySuccess(Q.text("Site.UserRoleDialog.SaveSuccess"));
            //        });
            //    },
            //}, {
            //    text: Q.text("Dialogs.CancelButton"),
            //    click: () => this.dialogClose(),
            //}];

            return opt;
        }
    }

    /* Lookup */
    /*export class BusinessUnitsLookupEditor extends Serenity.ServiceLookupEditor {
        constructor(container: JQuery, options: Serenity.ServiceLookupEditorOptions) {
            // options.includeColumns

            super(container, options);
        }

        protected getService(): string {
            return super.getService();
        }
    }*/

    /* Datagrid */

    export interface BusinessUnitsItem {
    }

    export interface BusinessUnitsOptions {
    }

    @Serenity.Decorators.registerClass()
    // export class UserRoleBusinessUnitsGrid extends Vit.GridEditorBase<UserTenantRoleRow> {
    export class UserRoleBusinessUnitsGrid extends Serenity.DataGrid<BusinessUnitsItem, BusinessUnitsOptions> {
        constructor(container: JQuery) {
            /* Set columns */
            const columns: Serenity.PropertyItem[] = [{
                name: UserTenantRoleRow.idProperty,
                alignment: "right",
                // width: ,
            },];
            Q.ScriptData.set("Columns.Serenity.UserTenantRole", columns);

            super(container);
        }

        protected getColumnsKey(): string {
            return "Serenity.UserTenantRole";
        }

        protected getGridCanLoad() {
            return false;
        }

        protected getLocalTextPrefix() {
            return UserTenantRoleRow.localTextPrefix;
        }

        protected getIdProperty(): string {
            return UserTenantRoleRow.idProperty;
        }
    }
}